/* globals window */

// eslint-disable-next-line import/no-cycle
import ForgotPassword from '../../products/components/login/ForgotPassword';
import Login from '../../products/components/login/Login';
import MagicLink from '../../products/components/login/MagicLink';

const LoginModal = (props) => {
  const { modal, setModal } = props;

  const handleLogin = () => {
    setModal('Login');
  };

  const handleForgotPassword = () => {
    setModal('ForgotPassword');
  };

  const handleMagicLink = () => {
    setModal('MagicLink');
  };

  const handleCloseModal = () => {
    setModal(null);
  };

  const redirectTo = `${window.location.pathname}${window.location.search}`;

  switch (modal) {
    case 'Login': {
      return (
        <Login
          onCloseModal={handleCloseModal}
          onForgotPassword={handleForgotPassword}
          onMagicLink={handleMagicLink}
          redirectLink={redirectTo}
        />
      );
    }
    case 'ForgotPassword': {
      return (
        <ForgotPassword
          onCloseModal={handleCloseModal}
          onLogin={handleLogin}
          redirectLink={redirectTo}
        />
      );
    }
    case 'MagicLink': {
      return (
        <MagicLink
          onCloseModal={handleCloseModal}
          onLogin={handleLogin}
          redirectLink={redirectTo}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default LoginModal;
